import React from 'react';
import ListarOrdenCompra from '../../../components/insumos/orden_compra/ListarOrdenCompra';
import { PageWrapper } from '../../../components/common';

const OrdenCompraPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarOrdenCompra />
    </PageWrapper>
  );
};

export default OrdenCompraPage;